import { RootState } from "../../utils/types";

export const selectCompanyDetails = (state: RootState) => state.companyDetails